import ajax from "./util-ajax";

const jQuery = window.jQuery;

const ajaxDelete = {
  deleteDropboxIntegration: deleteDropboxIntegration,
  deleteElementFromPod: deleteElementFromPod,
  deleteExceptionFromRule: deleteExceptionFromRule,
  deletePod: deletePod,
  deleteSpot: deleteSpot,
  deleteSpotFromPod: deleteSpotFromPod,
  deletePodFromCampaign: deletePodFromCampaign,
  deleteRule: deleteRule,
  deleteCampaign: deleteCampaign,
  deleteInviteFromStation: deleteInviteFromStation,
  deleteUserFromStation: deleteUserFromStation,
  deleteInvoiceCustomizations: deleteInvoiceCustomizations
};

export default ajaxDelete;

//

function deleteDropboxIntegration(integrationId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/station/integrations/${integrationId}/`
    })
    .fail(ajax.onFail);
}

function deleteElementFromPod(elementId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/pods/elements/${elementId}/`
    })
    .fail(ajax.onFail);
}

function deleteExceptionFromRule(exceptionId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/rules/exceptions/${exceptionId}/`
    })
    .fail(ajax.onFail);
}

function deletePod(podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/pods/${podId}/`
    })
    .fail(ajax.onFail);
}

function deleteSpotFromPod(podId, spotId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/pods/${podId}/spots/${spotId}/`
    })
    .fail(ajax.onFail);
}

function deletePodFromCampaign(campaignId, podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/campaigns/${campaignId}/pods/${podId}/`
    })
    .fail(ajax.onFail);
}

function deleteSpot(podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/spots/${podId}/`
    })
    .fail(ajax.onFail);
}

function deleteCampaign(campaignId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/campaigns/${campaignId}/`
    })
    .fail(ajax.onFail);
}

function deleteRule(ruleId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/rules/${ruleId}/`
    })
    .fail(ajax.onFail);
}

function deleteInviteFromStation(inviteId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/station/invites/${inviteId}/`
    })
    .fail(ajax.onFail);
}

function deleteUserFromStation(userId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/station/users/${userId}/`
    })
    .fail(ajax.onFail);
}

function deleteInvoiceCustomizations(customizationsId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `delete`,
      url: `/api/reports/station-customizations/${customizationsId}/`
    })
    .fail(ajax.onFail);
}
